import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import ReactToPrint from "react-to-print";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import "../../styles/VacationPrintPopupStyles.css";
import {formatMnDate} from "@mnjsplatform/data/lib/utils/formatData";

class RequestScheduleVacationPrintPopup extends Component {
    constructor(props, context) {
        super(props, context);

        this.refForPrint = React.createRef();
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem_report.reset());
            await this.props.dispatch(this.props.dataItem_report.initialize(this.props.rowKey, {
                withParams: false,
                newItem: true
            }));
        } catch (e) {
            console.error(e);
        }
    }
    renderRow = (h, i) => {
        return <tr>
            <td className="text-center">
                {h.NumMonthStr}
            </td>
            <td className="text-center">
                {h.NumDays}
            </td>
            <td className="text-center">
                {h.NumMonthToStr}
            </td>
            <td className="text-center">
                {h.NumDaysResult}
            </td>
        </tr>;

    };
    renderBody = (h) => {
        if(this.props.dataItem.rowsCount() === 0)
            return null;
        return (
            <div className="mn-report-body">
                <div className="text-center" style={{marginBottom: "50px"}}>
                    <h3>{i18next.t("Request")}</h3>
                </div>
                {`${i18next.t("Request_Schedule_Vacation_1")} ${h.row['BaseNumberDoc'] ?? ''} ${i18next.t("From")} ${formatMnDate(h.row['BaseDateDoc'])}`}
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col" colSpan="2">{i18next.t("Request_Schedule_Vacation_2")}</th>
                        <th scope="col" rowSpan="2">{i18next.t("Request_Schedule_Vacation_3")}</th>
                        <th scope="col" rowSpan="2">{i18next.t("Request_Schedule_Vacation_4")}</th>
                    </tr>
                    <tr>
                        <th scope="col" className="text-center">{i18next.t("Request_Schedule_Vacation_5")}</th>
                        <th scope="col" className="text-center">{i18next.t("Request_Schedule_Vacation_6")}</th>
                    </tr>
                    </thead>
                    <tbody>
                        {this.props.dataItem.dataTable().map(row => this.renderRow(row))}
                    </tbody>
                </table>
            </div>
        );
    }
    renderHeader = (h) => {
        return (
            <table className="mn-report-header">
                <tbody>
                <tr>
                    <td>
                        {h.row["BossProfessionName"]}
                        <hr/>
                        {this.props.appParams.myComp}
                        <hr/>
                        {h.row["BossFIO"]}
                        <hr/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div className="d-flex justify-content-end align-items-end">
                            <div>{i18next.t("From")}</div>
                            &nbsp;
                            {h.row["ProfessionName"]}
                        </div>
                        <hr/>
                    </td>
                </tr>
                <tr>
                    <td className="mn-report-header-line">
                        {h.row["AdmStructName"]}
                        <hr/>
                        <div className="text-center">
                            <sub>({i18next.t("HolidayAppSendToTitleDepartament_Label")})</sub>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="mn-report-header-line">
                        {h.row["FIO"]}
                        <hr/>
                        <div className="text-center">
                            <sub>({i18next.t("HolidayAppSendToPreferredName_Label")})</sub>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="mn-report-header-line">
                        {i18next.t("TabNum_Label")}: {h.row["TabNum"]}&nbsp;
                        <hr/>
                    </td>
                </tr>
                </tbody>
            </table>
        );
    }
    renderSignature = (h) => {
        return (
            <div className="row">
                <div className="col-3 text-center">
                    &nbsp;
                    <hr/>
                    <sub>({i18next.t("EmployeeSignature")})</sub>
                </div>
                <div className="col-5 text-center">
                    {h.row["FIO"]}
                </div>
                <div className="col-4 text-center">
                    "__" __________ 20__ {i18next.t("Year_SHort_Label")}.
                </div>
            </div>
        );
    }
    renderPrintForm = (h) => {
        return (
            <div id="vacationPrintForm" className="mn-report" ref={this.refForPrint}>
                {this.renderHeader(h)}
                {this.renderBody(h)}
                {this.renderSignature(h)}
            </div>
        );
    };
    renderPopupButtons = () => {
        return (<div className="modal-footer text-right">
            <ReactToPrint
                trigger={() => <button type="button"
                                       className="btn btn-regular -goahead ml1ex">{i18next.t("Print")}</button>}
                content={() => this.refForPrint.current}
            />

            <button type="button" className="btn btn-regular"
                    onClick={this.props.onClose}>{i18next.t("Close")}</button>
        </div>)
    };

    render() {
        return (
            <PopupWrapper popupVisible={true}
                          title={i18next.t("Print_RequestScheduleVacation")}
                          renderButtons={this.renderPopupButtons}
                          onClose={this.props.onClose}
            >
                <div ref={this.refForPrint}>
                    <ComplexParam dataItem={this.props.dataItem_report}
                                  showApplyButton={false} showSearchBar={false} readOnly={false}
                                  renderParams={this.renderPrintForm}
                    />
                </div>
            </PopupWrapper>
        );
    }
}

RequestScheduleVacationPrintPopup.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object.isRequired,
    rowKey: PropTypes.object,
    onClose: PropTypes.func.isRequired
};

RequestScheduleVacationPrintPopup.defaultProps = {
    title: i18next.t("Print_RequestScheduleVacation")
};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_report: state.vacationState.SchedHolidayTransfer_ReportEDocApp,
        appParams: state.appState.appParams
    }
}

export default connect(mapStateToProps)(RequestScheduleVacationPrintPopup);